import {ManualPagedTable} from "../../components/tables";
import React from "react";
import {LinkButton} from "../../components/buttons";
import {reportStatusTag} from "./reportStatus";

export function ReportsTable({asyncDataSource, refreshToken, onRowsLoaded, onViewClick}) {
    const columns = [
        {
            title: 'Id',
            dataIndex: 'id',
        },
        {
            title: 'Title',
            dataIndex: 'title',
        },
        {
            title: 'Created at',
            dataIndex: 'created_at',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            render: status => reportStatusTag(status),
        },
        {
            title: 'Actions',
            dataIndex: 'id',
            render: (id) => (
                <LinkButton
                    onClick={_ => onViewClick(id)}
                >
                    View
                </LinkButton>
            )
        },
    ];
    return (
        <ManualPagedTable
            id={"reports-table"}
            asyncDataSource={asyncDataSource}
            refreshToken={refreshToken}
            onRowsLoaded={onRowsLoaded}
            columns={columns}
            size={"small"}
            rowKey={x => x.id}
        />
    );
}
